import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { RewardInput } from "@core/types";
import * as api from "./api";
import type { RewardFilter } from "./api";

const listKey = (filter: RewardFilter) =>
  [
    "portal",
    "rewards",
    filter.active ?? null,
    filter.categoryId ?? null,
  ] as const;

export const useRewards = (filter: RewardFilter = {}) =>
  useQuery({
    queryKey: listKey(filter),
    queryFn: () => api.listRewards(filter),
  });

// Invalida toda variante de filtro de la lista (SPEC-210 no pagina: la
// pantalla siempre trae el catálogo completo y filtra en cliente, mismo
// criterio que `useGrandPrizes`).
export function useRewardMutations() {
  const client = useQueryClient();
  const invalidate = () =>
    client.invalidateQueries({ queryKey: ["portal", "rewards"] });
  return {
    create: useMutation({
      mutationFn: (input: RewardInput) => api.createReward(input),
      onSuccess: invalidate,
    }),
    edit: useMutation({
      mutationFn: ({ id, input }: { id: string; input: RewardInput }) =>
        api.editReward(id, input),
      onSuccess: invalidate,
    }),
    inactivate: useMutation({
      mutationFn: (id: string) => api.inactivateReward(id),
      onSuccess: invalidate,
    }),
  };
}
